//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import theme from './DroppedFile.scss';
import Loader from 'common/components/core/loader/Loader';
import Icon from 'common/components/core/icon';
import { Button, ButtonTypes } from 'common/components/core/button';
import NumberUtils from 'common/utils/NumberUtils';
import DialogStatusEnum from 'common/enums/DialogStatusEnum';

export type UploadedFileType = {
    file: File,
    fileStatus: string
};

export const UploadStatusEnum = {
    Initial: 'INITIAL',
    Uploading: 'UPLOADING',
    Success: 'SUCCESS',
    Fail: 'FAIL'
};

type FileProps = {
    file: UploadedFileType,
    theme: Object,
    fileIndex: number,
    dialogStatus: string,
    onRemoveFile: (fileIndex: string) => void
};

class DroppedFile extends React.PureComponent<FileProps, void> {
    onRemoveFile = e => {
        const { onRemoveFile, fileIndex } = this.props;
        onRemoveFile && onRemoveFile(fileIndex, e);
    };

    render() {
        const { file, fileIndex, theme, dialogStatus } = this.props;
        let fileStatusClass = '';
        if (file.fileStatus) {
            fileStatusClass = theme[file.fileStatus.toLowerCase()];
        }
        return (
            <div
                key={fileIndex}
                className={classnames(theme.file, {
                    [fileStatusClass]: fileStatusClass
                })}
            >
                <div className={theme.fileInfoWrap}>
                    <Icon
                        className={theme.fileIcon}
                        icon="document-icon"
                        theme={theme}
                    />
                    <div className={theme.fileInfo}>
                        <div className={theme.name}>{file.file.name}</div>
                        <div className={theme.size}>
                            {NumberUtils.formatNumber(
                                file.file.size / 1024,
                                true,
                                2
                            )}{' '}
                            KB
                        </div>
                    </div>
                </div>
                <div className={theme.fileStatus}>
                    {file.fileStatus === UploadStatusEnum.Initial &&
                    dialogStatus !== DialogStatusEnum.Loading ? (
                        <Button
                            buttonType={ButtonTypes.Icon}
                            icon="cancel-thin"
                            onClick={this.onRemoveFile}
                            className={theme.deleteBtn}
                            theme={theme}
                        />
                    ) : null}
                    {file.fileStatus === UploadStatusEnum.Uploading ||
                    (dialogStatus === DialogStatusEnum.Loading &&
                        file.fileStatus !== UploadStatusEnum.Success) ? (
                        <Loader active theme={theme} />
                    ) : null}
                    {file.fileStatus === UploadStatusEnum.Success ? (
                        <Icon
                            className={theme.successIcon}
                            icon="tickmark"
                            theme={theme}
                        />
                    ) : null}
                    {file.fileStatus === UploadStatusEnum.Fail ? (
                        <Icon
                            className={theme.successIcon}
                            icon="alert"
                            theme={theme}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

const ThemedDroppedFile = themr('DroppedFile', theme)(DroppedFile);
export { ThemedDroppedFile as DroppedFile };
export default ThemedDroppedFile;
